var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtfGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.21818C16.565 6.21818 18.4141 6.92985 19.8725 8.31818L23.8683 4.32235C21.4416 2.06485 18.2741 0.676514 14.5 0.676514C9.02829 0.676514 4.29745 3.81485 1.99329 8.38818L6.64829 11.999C7.75079 8.67985 10.8483 6.21818 14.5 6.21818Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.905 14.9973C27.905 14.0815 27.8175 13.1948 27.6833 12.3431H14.5V17.6048H22.0483C21.71 19.3315 20.73 20.8015 19.26 21.7931L23.7692 25.2931C26.4 22.8548 27.905 19.2498 27.905 14.9973Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6425 17.354C6.3625 16.5082 6.19917 15.6098 6.19917 14.6765C6.19917 13.7432 6.35667 12.8449 6.6425 11.999L1.9875 8.38818C1.03667 10.2782 0.5 12.4132 0.5 14.6765C0.5 16.9398 1.03667 19.0748 1.99333 20.9648L6.6425 17.354Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4997 28.6762C18.2797 28.6762 21.4589 27.4337 23.7689 25.2871L19.2597 21.7871C18.0055 22.6329 16.3897 23.1287 14.4997 23.1287C10.848 23.1287 7.75052 20.6671 6.64218 17.3479L1.98718 20.9587C4.29718 25.5379 9.02802 28.6762 14.4997 28.6762Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtfGoogleIcon);
export default __webpack_public_path__ + "static/media/ftf_google_icon.e6ba1a82f6482b3281732b605ed3c764.svg";
export { ForwardRef as ReactComponent };